import React from "react";
import { NavLink } from "react-router-dom";

export interface SidebarItem {
  title: string;
  href: string;
  isHeader?: boolean;
}

interface DocsSidebarProps {
  items: SidebarItem[];
}

export const DocsSidebar = ({ items }: DocsSidebarProps) => {
  return (
    <nav className="flex flex-col gap-1">
      {items.map((item, idx) => {
        if (item.isHeader) {
          return (
            <h5 key={idx} className="mt-6 mb-2 text-xs font-bold text-black uppercase tracking-wider px-2">
              {item.title}
            </h5>
          );
        }
        return (
          <NavLink
            key={idx}
            to={item.href}
            className={({ isActive }) =>
              `text-sm py-1.5 px-3 rounded-md transition-all duration-200 ${
                isActive
                  ? "font-semibold text-[#0070f3] bg-[#0070f3]/5"
                  : "text-slate-600 hover:text-black hover:bg-[#fafafa]"
              }`
            }
          >
            {item.title}
          </NavLink>
        );
      })}
    </nav>
  );
};

export default DocsSidebar;
